<template>

  <BasicLayout>

    <div>

      <!-- SEARCH -->
      <Search :searching="searching"
              @search="search"
              @closeSearch="searching = false"
              @clearSearch="clearSearch"/>

      <div class="elevation-2">

        <!-- TOOLBAR -->
        <v-toolbar flat="flat">
          <v-toolbar-title>Matches</v-toolbar-title>
          <v-flex class="ml-5" md3="md3">
            <v-text-field v-show="!loading && !searching"
                          v-model="quickSearchID"
                          placeholder="Search by ID"
                          :clearable="true"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-icon class="mr-2"
                  v-if="!searching"
                  title="Show the search"
                  @click="searching = true">mdi-magnify</v-icon>
          <v-icon title="Create match"
                  @click="dialog = true">mdi-plus</v-icon>
        </v-toolbar>

        <!-- TABLE -->
        <Table ref="table"
               :headers="headers"
               :items="items"
               :pagination="pagination"
               :paginationOptions="paginationOptions"
               :totalItems="pagination.totalItems"
               :loading="loading"
               @paginationUpdate="paginationUpdate"
               @edit="toggleEdit"
               @del="del"
               @suspend="toggleSuspendConfirm($event, false)"
               @unsuspend="toggleSuspendConfirm($event, true)"
               @reprocess="toggleReprocessConfirm"
               @transfer="startTransfer"
               @privatize="privatize"/>

        <!-- CREATE / EDIT -->
        <Dialog :dialog="dialog"
                :dialogState="dialogState"
                :currentEditedMatch="editedItem"
                :errorMessage="errorMessage"
                @dialogClosed="close"
                @createMatch="createMatch"
                @editMatch="editMatch"/>

      </div>
    </div>

    <!-- CONFIRM DELETE MATCHES WITH VIDEOS -->
    <ConfirmPopup :isActive="deleteConfirmToggled"
                  :title="'Warning : this match has videos'"
                  :text="'If you confirm delete, all videos on this match will be deleted\n\nThis action is irreversible'"
                  :cancelButtonText="'Cancel'"
                  :confirmButtonText="'Delete'"
                  @cancel="cancelDeleteConfirm"
                  @confirm="confirmDeleteConfirm"/>

    <!-- CONFIRM SUSPEND VIDEOS -->
    <ConfirmPopup :isActive="suspendConfirmToggled"
                  :title="suspendConfirmSuspended ? 'Unsuspend all videos on this match ?' : 'Suspend all videos on this match ?'"
                  :text="'This action is irreversible'"
                  :cancelButtonText="'Cancel'"
                  :confirmButtonText="suspendConfirmSuspended ? 'Unsuspend' : 'Suspend'"
                  @cancel="cancelSuspendConfirm"
                  @confirm="suspendConfirmSuspended ? confirmUnsuspendConfirm() : confirmSuspendConfirm()"/>

    <!-- CONFIRM REPROCESS MATCH -->
    <ConfirmPopup :isActive="reprocessConfirmToggled"
                  :title="'Reprocess videos on this match ?'"
                  :text="''"
                  :cancelButtonText="'Cancel'"
                  :confirmButtonText="'Reprocess'"
                  @cancel="cancelReprocessConfirm"
                  @confirm="confirmReprocessConfirm"/>

    <!-- LOADER -->
    <LoadingPopup :displayed="loaderDisplayed"
                  :title="loaderTitle"
                  :text="loaderText"/>

  </BasicLayout>

</template>

<script>

import BasicLayout from '../layouts/BasicLayout'
import Search from '../components/matches/Search'
import Table from '../components/matches/Table'
import Dialog from '../components/matches/Dialog'
import ConfirmPopup from '../components/common/ConfirmPopup'
import LoadingPopup from '../components/common/LoadingPopup'

export default {
  name: 'MatchesPage',
  components: {
    BasicLayout,
    Search,
    Table,
    Dialog,
    ConfirmPopup,
    LoadingPopup
  },
  data () {
    return {
      loading: false,

      items: [],

      headers: [
        {
          text: 'ID',
          value: 'id',
          sortable: false,
          width: '1%',
          countries: ['FR', 'US']
        },
        {
          text: 'Sport',
          value: 'sportID',
          sortable: false,
          width: '1%',
          countries: ['FR', 'US']
        },
        {
          text: 'Date',
          value: 'date',
          sortable: false,
          width: '1%',
          countries: ['FR', 'US']
        },
        {
          text: 'Club 1',
          value: 'club1Alias',
          sortable: false,
          width: '200px',
          countries: ['FR', 'US']
        },
        {
          text: 'Team 1',
          value: 'team1Name',
          sortable: false,
          width: '200px',
          countries: ['US']
        },
        {
          text: 'Club 2',
          value: 'club2Alias',
          sortable: false,
          width: '200px',
          countries: ['FR', 'US']
        },
        {
          text: 'Team 2',
          value: 'team2Name',
          sortable: false,
          width: '200px',
          countries: ['US']
        },
        {
          text: 'Competition',
          value: 'competitionName',
          sortable: false,
          width: '240px',
          countries: ['FR', 'US']
        },
        {
          text: 'Category',
          value: 'categoryName',
          sortable: false,
          width: '1%',
          countries: ['FR', 'US']
        },
        {
          text: 'Place',
          value: 'placeName',
          sortable: false,
          width: '200px',
          countries: ['FR', 'US']
        }
      ],

      quickSearchID: null,

      searching: false,
      searchParams: {},

      pagination: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      },
      paginationOptions: [10, 50, 100],

      dialog: null,
      editedItem: null,
      editedIndex: -1,

      deleteConfirmToggled: false,
      deleteConfirmMatch: null,

      suspendConfirmToggled: false,
      suspendConfirmMatch: null,
      suspendConfirmSuspended: false,

      reprocessConfirmToggled: false,
      reprocessConfirmMatch: null,

      transferVideos: [],
      transferSummaries: [],

      errorMessage: '',

      loaderDisplayed: false,
      loaderTitle: null,
      loaderText: null
    }
  },
  mounted () {
    this.setHeaders()
    // this.loadData()
  },
  methods: {
    setHeaders () {
      this.headers = this.headers.filter(item => item.countries.includes(this.$country))
    },
    loadData () {
      this.loading = true
      this.searching = false

      let params = {
        page: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        withTotalItems: true,
        avoidCache: true,
        sortBy: 'date:desc'
      }

      if (this.searchParams.name) {
        params.name = this.searchParams.name
      }
      if (this.searchParams.sportID) {
        params.sportID = this.searchParams.sportID
      }
      if (this.searchParams.federationID) {
        params.federationID = this.searchParams.federationID
      }
      if (this.searchParams.competitionID) {
        params.competitionID = this.searchParams.competitionID
      }
      if (this.searchParams.placeID) {
        params.placeID = this.searchParams.placeID
      }
      if (this.searchParams.clubID) {
        params.clubID = this.searchParams.clubID
      }
      if (this.searchParams.otherClubID) {
        params.otherClubID = this.searchParams.otherClubID
      }
      if (this.searchParams.teamID) {
        params.teamID = this.searchParams.teamID
      }
      if (this.searchParams.otherTeamID) {
        params.otherTeamID = this.searchParams.otherTeamID
      }
      if (this.searchParams.startDate) {
        params.startDate = this.searchParams.startDate
      }
      if (this.searchParams.endDate) {
        params.endDate = this.searchParams.endDate
      }
      if (this.searchParams.hasVideos) {
        params.hasVideos = this.searchParams.hasVideos
      }
      if (this.searchParams.hasVideosFrom) {
        params.hasVideosFrom = this.searchParams.hasVideosFrom
      }

      this.$store.dispatch('searchMatches', params)
        .then(resp => {
          this.pagination.totalItems = resp.totalItems
          this.items = resp.items
          this.loading = false
        })
        .catch(() => {
          alert('Error loading matches')
          this.loading = false
        })
    },

    search (params) {
      this.pagination = {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      }
      this.searchParams = params
      this.loadData()
    },

    clearSearch () {
      this.searchParams = {}
    },

    createMatch (match) {
      if (this.checkFields(match)) {
        return
      }

      if (this.$country === 'US') {
        if (!match.club1ID && !match.team1ID) {
          match.club1ID = 'defaultclub000000000'
          match.team1ID = 'defaultteam000000000'
        }
        if (!match.club2ID && !match.team2ID) {
          match.club2ID = 'defaultclub000000000'
          match.team2ID = 'defaultteam000000000'
        }
      }

      this.displayLoader({
        title: 'Creating match'
      })
      this.$store.dispatch('createMatch', match)
        .then(resp => {
          this.hideLoader()
          this.showCreatedMatch(resp.id)
          this.close()
        })
        .catch(() => {
          this.hideLoader()
          alert('Error creating match')
        })
    },

    checkFields (match) {
      if (!match.sportID) {
        this.errorMessage = 'Please select a sport'
        return true
      }
      if (!match.federationID) {
        this.errorMessage = 'Please select a federation'
        return true
      }
      if (!match.date) {
        this.errorMessage = 'Please enter a date'
        return true
      }

      if (this.$country === 'FR') {
        if (!match.club1ID) {
          this.errorMessage = 'Please select club 1'
          return true
        }
        if (!match.club2ID) {
          this.errorMessage = 'Please select club 2'
          return true
        }
      } else {
        if (!match.club1ID && !match.club2ID) {
          this.errorMessage = 'Please select at least one team'
          return true
        }
        if (match.club1ID && !match.team1ID) {
          this.errorMessage = 'Please select team 1'
          return true
        }
        if (match.club2ID && !match.team2ID) {
          this.errorMessage = 'Please select team 2'
          return true
        }
      }

      return false
    },

    showCreatedMatch (id) {
      this.$store.dispatch('getMatch', id)
        .then(resp => {
          this.items = [resp]
        })
    },

    toggleEdit (index) {
      this.editedIndex = index
      this.editedItem = JSON.parse(JSON.stringify(this.items[index]))
      this.dialog = true
    },

    close () {
      this.dialog = false
      this.editedItem = null
      this.editedIndex = -1
      this.errorMessage = ''
    },

    editMatch (editedmatch) {
      let match = JSON.parse(JSON.stringify(editedmatch))
      if (this.checkFields(match)) {
        return
      }

      if (this.$country === 'US') {
        if (!match.club1ID && !match.team1ID) {
          match.club1ID = 'defaultclub000000000'
          match.team1ID = 'defaultteam000000000'
        }
        if (!match.club2ID && !match.team2ID) {
          match.club2ID = 'defaultclub000000000'
          match.team2ID = 'defaultteam000000000'
        }
      }

      this.displayLoader({
        title: 'Editing match'
      })
      this.$store.dispatch('patchMatch', {
        id: this.items[this.editedIndex].id,
        patch: match
      })
        .then(() => {
          this.hideLoader()
          this.updateItem(this.editedIndex, match)
          this.close()
        })
        .catch(() => {
          this.hideLoader()
          alert('Error editing club')
        })
    },
    updateItem (index, patch) {
      this.items[index].club1ID = patch.club1ID
      this.items[index].club2ID = patch.club2ID
      this.items[index].date = patch.date
    },

    del (match) {
      this.displayLoader({
        title: 'Deleting match'
      })
      this.$store.dispatch('deleteMatch', match.id)
        .then(() => {
          this.hideLoader()
          this.loadData()
        })
        .catch(err => {
          if (err.response.status === 409) {
            this.hideLoader()
            this.deleteConfirmToggled = true
            this.deleteConfirmMatch = match
          } else {
            this.hideLoader()
            alert('Error deleting match')
          }
        })
    },
    cancelDeleteConfirm () {
      this.deleteConfirmMatch = null
      this.deleteConfirmToggled = false
    },
    confirmDeleteConfirm () {
      this.displayLoader({
        title: 'Deleting match'
      })
      this.$store.dispatch('confirmDeleteMatch', this.deleteConfirmMatch.id)
        .then(() => {
          this.hideLoader()
          this.deleteConfirmMatch = null
          this.deleteConfirmToggled = false
          this.loadData()
        })
        .catch(() => {
          this.hideLoader()
          alert('Error deleting match')
        })
    },

    toggleSuspendConfirm (match, suspended) {
      this.suspendConfirmMatch = match
      this.suspendConfirmSuspended = suspended
      this.suspendConfirmToggled = true
    },
    cancelSuspendConfirm () {
      this.suspendConfirmMatch = null
      this.suspendConfirmSuspended = false
      this.suspendConfirmToggled = false
    },
    confirmSuspendConfirm () {
      this.displayLoader({
        title: 'Suspending all videos'
      })
      this.$store.dispatch('suspendMatchVideos', this.suspendConfirmMatch.id)
        .then(() => {
          this.hideLoader()
          this.suspendConfirmMatch = null
          this.suspendConfirmToggled = false
          this.loadData()
        })
        .catch(() => {
          this.hideLoader()
          alert('Error suspending match videos')
        })
    },
    confirmUnsuspendConfirm () {
      this.displayLoader({
        title: 'Unsuspending match videos'
      })
      this.$store.dispatch('unsuspendMatchVideos', this.suspendConfirmMatch.id)
        .then(() => {
          this.suspendConfirmMatch = null
          this.suspendConfirmSuspended = false
          this.suspendConfirmToggled = false
          this.loadData()
        })
        .catch(() => {
          alert('Error unsuspending match videos')
        })
        .finally(() => {
          this.hideLoader()
        })
    },
    toggleReprocessConfirm (match) {
      this.reprocessConfirmMatch = match
      this.reprocessConfirmToggled = true
    },
    cancelReprocessConfirm () {
      this.reprocessConfirmMatch = null
      this.reprocessConfirmToggled = false
    },
    confirmReprocessConfirm () {
      this.displayLoader({
        title: 'Reprocessing match videos'
      })
      this.$store.dispatch('patchMatch', {
        id: this.reprocessConfirmMatch.id,
        patch: {
          reprocess: true
        }
      })
        .then(() => {
          this.hideLoader()
          this.reprocessConfirmMatch = null
          this.reprocessConfirmToggled = false
          this.loadData()
        })
        .catch(() => {
          this.hideLoader()
          alert('Error reprocessing match')
        })
    },

    startTransfer (frommatch, tomatch, fromAuthors) {
      this.transferVideos = []
      this.transferSummaries = []
      this.loadMatchVideos(frommatch, fromAuthors)
        .then(() => {
          this.assignVideosToMatch(frommatch, tomatch, 0)
        })
        .catch(() => {
          this.closeTransfer(frommatch)
          alert('Error loading videos')
        })
    },

    endTransfer (frommatch, tomatch) {
      this.deleteSourceMatchSummaries()

      this.reprocessMatch(tomatch)
        .then(() => {
          this.closeTransfer(frommatch)
        })
        .catch(() => {
          this.closeTransfer(frommatch)
          alert('Error reprocessing match')
        })
    },

    closeTransfer (match) {
      this.transferVideos = []
      this.transferSummaries = []
      this.$refs.table.closeTransfer(match.id)
      this.close()
      this.hideLoader()
    },

    loadMatchVideos (match, authors) {
      if (!authors) throw Error('no author selected')
      return new Promise((resolve, reject) => {
        this.displayLoader({
          title: 'Retrieving match videos...',
          text: 'This operation may take a while\n\nPlease do not close this tab'
        })
        this.$store.dispatch('searchVideos', {
          page: 0,
          pageSize: 300,
          matchID: match.id
        })
          .then(resp => {
            const authorVideos = resp.items.filter(i => authors.includes(i.authorID))

            if (!authorVideos.length) {
              this.closeTransfer(match)
              this.closePrivatization(match)
              alert('The source match has no videos')
            } else {
              for (let video of authorVideos) {
                if (video.type === 'summary') {
                  this.transferSummaries.push(video)
                } else {
                  this.transferVideos.push(video)
                }
              }
              resolve()
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    assignVideosToMatch (frommatch, tomatch, videoindex) {
      this.displayLoader({
        title: `Transferring video ${videoindex + 1} / ${this.transferVideos.length}...`,
        text: 'This operation may take a while\n\nPlease do not close this tab'
      })
      this.$store.dispatch('patchVideo', {
        id: this.transferVideos[videoindex].id,
        patch: {
          matchID: tomatch.id,
          sportID: tomatch.sportID
        }
      })
        .then(() => {
          if (videoindex < this.transferVideos.length - 1) {
            this.assignVideosToMatch(frommatch, tomatch, videoindex + 1)
          } else {
            this.endTransfer(frommatch, tomatch)
          }
        })
        .catch(() => {
          this.closeTransfer(frommatch)
          alert(`Error transferring video ${videoindex + 1} / ${this.transferVideos.length}`)
        })
    },

    deleteSourceMatchSummaries () {
      for (let summary of this.transferSummaries) {
        this.$store.dispatch('deleteVideo', summary.id)
      }
    },

    reprocessMatch (match) {
      return new Promise((resolve, reject) => {
        this.displayLoader({
          title: 'Reprocessing matches...',
          text: 'This operation may take a while\n\nPlease do not close this tab'
        })
        this.$store.dispatch('patchMatch', {
          id: match.id,
          patch: {
            reprocess: true
          }
        })
          .then(() => {
            resolve()
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    privatize (match, fromAuthors) {
      this.displayLoader({
        title: 'Making videos private',
        text: 'Please wait...'
      })
      this.$store.dispatch('privatizeMatchVideos', {
        id: match.id,
        authorIDs: fromAuthors
      })
        .then(() => {
          this.closePrivatization(match)
        })
        .catch(() => {
          this.closePrivatization(match)
          alert('An error occured')
        })
    },

    closePrivatization (match) {
      this.$refs.table.closePrivatization(match.id)
      this.close()
      this.hideLoader()
    },

    displayLoader (content) {
      this.loaderTitle = content.title || null
      this.loaderText = content.text || null
      this.loaderDisplayed = true
    },
    hideLoader () {
      this.loaderDisplayed = false
      this.loaderTitle = null
      this.loaderText = null
    },

    paginationUpdate (v) {
      if (this.pagination.page !== v.page || this.pagination.rowsPerPage !== v.rowsPerPage) {
        this.pagination = {
          page: v.page,
          rowsPerPage: v.rowsPerPage,
          totalItems: this.pagination.totalItems
        }
        this.loadData()
      }
    }

  },
  computed: {
    dialogState () {
      return this.editedIndex === -1 ? 'create' : 'edit'
    }
  },
  watch: {
    'quickSearchID' () {
      if (this.quickSearchID) {
        if (this.quickSearchID.length !== 20) {
          this.quickSearchID = null
          return
        }
        this.loading = true
        this.$store.dispatch('getMatch', this.quickSearchID)
          .then(resp => {
            this.items = [resp]
            this.loading = false
          })
          .catch(() => {
            this.loading = false
            alert('Error loading match')
          })
      } else {
        this.loadData()
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/MatchesPage.vue